// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let DocumentV3Api = class DocumentV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Creates a new Document.
     * @param documentCreateModel Document Create Model object
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentCreateByProgramId(documentCreateModel, xProgramId) {
        const _url_ = '/document/v3/Document';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentCreateModel' is not null or undefined
        if (documentCreateModel === null || documentCreateModel === undefined) {
            throw new Error('Required parameter documentCreateModel was null or undefined when calling documentCreateByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentCreateModel, "DocumentCreateModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LongDocumentDocumentCreateModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a Document by Document identifier.
     * @param documentId Document identifier.
     * @param xProgramId The program id from the list of allowed program ids
     */
    async documentGetByProgramId(documentId, xProgramId) {
        const _url_ = '/document/v3/Document/{documentId}'
            .replace('{' + 'documentId' + '}', encodeURIComponent(String(documentId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentId' is not null or undefined
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling documentGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Creates a new Document.
     * @param documentPdfDocumentModel InsertDocumentRequestModel object
     * @param xProgramId The program id from the list of allowed program ids
     */
    async pdfDocumentCreateByProgramId(documentPdfDocumentModel, xProgramId) {
        const _url_ = '/document/v3/PdfDocument';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentPdfDocumentModel' is not null or undefined
        if (documentPdfDocumentModel === null || documentPdfDocumentModel === undefined) {
            throw new Error('Required parameter documentPdfDocumentModel was null or undefined when calling pdfDocumentCreateByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentPdfDocumentModel, "DocumentPdfDocumentModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentLongResponse");
        }
        return response;
    }
};
DocumentV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], DocumentV3Api);
export { DocumentV3Api };
//# sourceMappingURL=documentV3Api.js.map